<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des échéances</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">

      </div>
      <div class="col-md-4" v-if="point_ventes.length > 1">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Filtrer par Point de vente
          </label>
          <div class="d-flex align-items-center" style="width: 200px;">
            <Multiselect v-model="point_vente" :options="point_ventes" :searchable="true" track-by="label" label="label"
              placeholder="Sélectionner un point de vente" />
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher une échéance" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Echeance
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Reste à payer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Créance
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Client
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(echeance, index) in echeances" :key="index">
              <td class="shadow-none lh-1 fw-medium ">{{ format_Date(echeance.date) }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ separateur(echeance.montant) }} </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ separateur(echeance.reste_a_payer) }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ echeance?.creance?.refCrean }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ echeance?.creance?.client?.nomClient && echeance?.creance?.client.prenomClient ?
                  `${echeance?.creance?.client.nomClient} ${echeance?.creance?.client.prenomClient}` :
                  echeance?.creance?.client.sigle }}
              </td>
              <td>
                      <span :class="['badge', getStatutBadge(echeance).class]">{{ getStatutBadge(echeance).text }}</span>
                    </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { Form, Field, ErrorMessage } from 'vee-validate';
import { format_Date, showModal, hideModal, suppression, error, success, separateur } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Swal from "sweetalert2";
import { useRoute, useRouter } from 'vue-router';
import * as Yup from 'yup';
import Multiselect from "@vueform/multiselect";
import { Echeance } from "@/models/Echeance";

export default defineComponent({
  name: "ListeEcheance",
  components: {
    PaginationComponent,
    Form,
    Field,
    Multiselect,
    ErrorMessage
  },
  setup() {
    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllEcheance(point_vente.value);
    });

    const echeancesSchema = Yup.object().shape({
      observation: Yup.string().required("L'observation est obligatoire"),
    });
    const echeancesForm = ref(null);
    const echeances = ref<Array<Echeance>>([]);
    const selectedItem = ref(0);
    const echeance = ref<Echeance>();
    const router = useRouter();
    const route = useRoute();
    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    let point_vente = ref<string>("");
    let point_ventes = ref([]);


    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllEcheance(page_, limit_);
      } catch (error) {
        //
      }
    };
    const echeanceii = ref();
    const openModal = (id: number) => {
      echeanceii.value = id;
    };

    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllEcheance(point_vente.value, page.value, limit.value, searchTerm.value);
    }
    // END PAGINATE
    function getAllEcheance(point_vent, page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/echeances?page=${page}&limit=${limi}&mot=${searchTerm}&cat=4&pointvente=${point_vent}&`)
        .then(({ data }) => {
          echeances.value = data.data.data;
          console.log(data.data, "Données récupérées")
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

 /*   const getStatut = (echeance: any) => {
      const today = new Date();
      const echeanceDate = new Date(echeance.date);

      if (echeance.reste_a_payer === 0) {
        return "Payé";
      }

      if (echeanceDate > today) {
        if (echeance.reste_a_payer > 0 && echeance.reste_a_payer < echeance.montant) {
          return "En cours";
        }
        return "En attente";
      }

      if (echeanceDate < today && echeance.reste_a_payer === echeance.montant) {
        return "Impayé";
      }

      if (echeance.reste_a_payer > 0 && echeance.reste_a_payer < echeance.montant) {
        return "En cours";
      }

      return "Impayé";
    };

    const getStatutClass = (echeance: any) => {
      const statut = getStatut(echeance);
      return {
        'badge badge-light-warning': statut === 'En attente',
        'badge badge-light-info': statut === 'En cours',
        'badge badge-light-success':  statut === 'Payé',
        'badge badge-light-danger': statut === 'Impayé'
      };
    };
*/
// Méthode pour déterminer le statut et le badge de chaque échéance
    const getStatutBadge = (echeance: any) => {
      const today = new Date();
      const echeanceDate = new Date(echeance.date);

      // 1. Payé (reste_a_payer = 0)
      if (echeance.reste_a_payer === 0) {
        return { class: 'badge badge-light-success', text: 'Payé' };
      }

      // 2. En attente (date dans le futur, aucun paiement partiel)
      if (echeanceDate > today && echeance.reste_a_payer === echeance.montant) {
        return { class: 'badge badge-light-warning', text: 'En attente' };
      }

      // 3. En cours (paiement partiel, avant ou après la date)
      if (echeance.reste_a_payer > 0 && echeance.reste_a_payer < echeance.montant) {
        return { class: 'badge badge-light-info', text: 'En cours' };
      }

      // 4. Impayé (date dépassée, aucun paiement)
      if (echeanceDate < today && echeance.reste_a_payer === echeance.montant) {
        return { class: 'badge badge-light-danger', text: 'Impayé' };
      }

      // Par défaut
      return { class: 'badge badge-light-secondary', text: 'Inconnu' };
    };


    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    return {
      echeance,
      openModal,
      echeancesForm,
      checkPermission,
      suppression,
      format_Date,
      separateur,
      echeances,
      page,getStatutBadge,
      // getStatut,
       //getStatutClass,
      totalPages,
      limit,
      selectedItem,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      echeancesSchema,
      //getEtatBadge,
      point_ventes,
      point_vente

    };
  },
});
</script>